import { ApiError } from "../api/client";

export function productStep(operation: "workspaces" | "eligibility" | "activation" | "workspace-selection", state: "started" | "succeeded" | "failed", counts: { count?: number; eligibleCount?: number; freeForLife?: boolean } = {}, error?: unknown) {
  if (!__MZN_LOCAL_FIXTURES__) return;
  const code = error instanceof ApiError && /^[A-Z0-9_]{1,96}$/.test(error.code) ? error.code : undefined;
  const details = { operation, state, ...counts, ...(code ? { code } : {}) };
  const entry = "[MZN Products] " + JSON.stringify(details);
  if (state === "failed") console.warn(entry);
  else console.info(entry);
}
